// Repeat on anything that sets its own color. `text-muted-foreground` overrides it.
export const HUB_DARK_TEXT_CLASS = 'dark:text-gz-neutral-100';

// Square, because the row bleeds to both edges of the sheet rather than sitting on it as a card.
export const HUB_ALTERNATE_SURFACE_CLASS = 'light:bg-gz-surface-medium dark:bg-gz-blue-800';
